import { Button, ModalBody, ModalFooter, ModalHeader, Text } from "@chakra-ui/react";
import ScrollTriggeredModal from "../shared/ScrollTriggeredModal";
import { LinkButton } from "../shared/generic";
import { ChevronRightIcon } from "@chakra-ui/icons";

export default function ModalFindYourTwin({ onClose }) {
  return (
    <ScrollTriggeredModal scrollPos={{ base: 1000, md: 1300 }} delay={1000}>
      <ModalHeader>🎓🎉 Find your twin at your dream school</ModalHeader>
      <ModalBody>
        <Text fontSize="lg">
          We just created a <b>new matching algorithm</b> that helps you find your twin at your
          dream school. To get the best results, we&apos;d love to learn a little bit more about
          you.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button mr={3} onClick={onClose}>
          Close
        </Button>
        <LinkButton
          colorScheme="green"
          rightIcon={<ChevronRightIcon />}
          href="/get-started/hs?askAdditionalQuestions=true"
        >
          Try it out
        </LinkButton>
      </ModalFooter>
    </ScrollTriggeredModal>
  );
}
